export class AnswerGiven {
  value :any
  display=""
  valueType=""

}
